<p>mssidcproposalpage works!</p>
<div class="text-center">
  <button style="margin-right: 16px;" id="btnverifyProposal" (click)="VerifyProposal()">Verify Proposal</button>
</div>

